//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios, { CancelToken } from "axios";

export default {
  props: {
    period: String,
    curperiod: String,
    customer: String,
    brand: String,
    status: String,
    viewstatus: String,
    loc: Array,
    sono: String,
    viewclosed: String,
    tab: String
  },
  data() {
    return {
      objWeek: {
        fg: 0,
        pcs_complete: 0,
        pcs_complete_color: "",
        pcs_complete_percent: 0,
        pcs_otif: 0,
        pcs_otif_color: "",
        pcs_otif_percent: 0,
        pcs_total: 0,
        pending: 0,
        ship_pcs: 0,
        ship_pcs_otif: 0,
        sub_complete: 0,
        sub_complete_color: "",
        sub_complete_percent: 0,
        sub_otif: 0,
        sub_otif_color: "",
        sub_otif_percent: 0,
        sub_total: 0,
        total_order: 0
      },
      bar2: false,
      so: {},
      listso: [],
      listdetail: [],
      rCircle: 19,
      thumbStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.75
      },

      barStyle: {
        right: "2px",
        borderRadius: "0px",
        backgroundColor: "#027be3",
        width: "2px",
        opacity: 0.2
      }
    };
  },
  created() {
    this.CheckLocal();
    this.LoadFirst();
  },
  mounted() {},
  methods: {
    LoadFirst() {
      this.pulling = setTimeout(() => {
        this.LoadData();
      }, 1000);
    },

    async LoadData() {
      //   console.log(this.loc)
      const postjson = {
        authen: { keycode: this.$keycode },
        filter: {
          wk: this.period,
          so: this.sono,
          loc: this.loc,
          customer: this.customer,
          brand: this.brand,
          viewclosed: this.viewclosed
        }
      };

      await axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/board7/shipwk_sum_new`,
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.listso = res.data.rows;
        this.objWeek = res.data.period;
        this.loading = false;
      });
    },

    getClassSize() {
      if (this.$q.screen.width <= 1440) {
        return "text-h4 fnt";
      } else {
        return "text-h3 fnt";
      }
    },
    getClassSize2() {
      if (this.$q.screen.width <= 1440) {
        return "text-h6 fnt";
      } else {
        return "text-h5 fnt";
      }
    },

    getcurperiod(pc, pd) {
      if (pc == pd) {
        return "bg-orange-3";
      } else {
        return "bg-grey-10";
      }
    },

    openDialog(so) {
      // console.log("SO = ", so);
      this.bar2 = true;
      this.so = so;
      let params = new FormData();

      // params.append("wk", so.SHIP_WK);
      // params.append("so", so.SO_NO_DOC);
      // params.append("loc", so.LOC);
      //params.append("so", obj.SO_NO_DOC);
      axios({
        method: "post",
        url: `${this.$apiflask}/nygctroom/board7/soDetail_new`,
        data: { loc: so.LOC, so: so.SO_NO_DOC, wk: so.SHIP_WK }
      }).then(res => {
        // console.log(res.data);
        this.listdetail = res.data.rows;
        
      });
      
    }
  }
};
